module.exports = __webpack_public_path__ + "static/media/logo.b13092d3.svg";